module.exports = __webpack_public_path__ + "media/images/briefly_logo24-91abcdfaff9bfcc0439abd6dc881b354.svg";